// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetStickyHeaderVisibility = () => getClaimDefaultState().isStickyHeaderVisible;

const setStickyHeaderVisibility = (state, action) => action.isVisible;

export default (state = getClaimDefaultState().isStickyHeaderVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_BATTERY_STICKY_HEADER_VISIBILITY]: setStickyHeaderVisibility,
        [actions.RESET_CLAIM_BATTERY]: resetStickyHeaderVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/battery/reducers/is-sticky-header-visible.js